import { render, staticRenderFns } from "./TheBlogEmpty.vue?vue&type=template&id=4604ec86&scoped=true&"
import script from "./TheBlogEmpty.vue?vue&type=script&lang=js&"
export * from "./TheBlogEmpty.vue?vue&type=script&lang=js&"
import style0 from "./TheBlogEmpty.vue?vue&type=style&index=0&id=4604ec86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4604ec86",
  null
  
)

export default component.exports